import {useDispatch} from 'react-redux';

import {UserLayoutRequest} from 'src/openapi/admin/models/UserLayoutRequest';
import {useAppSelector} from 'src/store/hooks';

import {LayoutsPageState, resetScopeCriteria, setScopeCriteria} from '../slices/layoutsSlice';

export function useLayoutCriteria(scopeKey: string) {
    const dispatch = useDispatch();
    const criteria = useAppSelector(
        (state: LayoutsPageState) => state.userPage.tabs.content.layouts.criteriaByScope[scopeKey],
    );

    const setCriteria = (patch: Partial<UserLayoutRequest>) => {
        dispatch(setScopeCriteria({scopeKey, patch}));
    };

    const reset = () => {
        dispatch(resetScopeCriteria(scopeKey));
    };

    const setPage = (page: number) => {
        setCriteria({page: {...criteria.page, currentPage: page}});
    };

    const setPageSize = (size: number) => {
        setCriteria({page: {...criteria.page, currentPage: 1, pageSize: size}});
    };

    const setSort = (
        sortBy: UserLayoutRequest['sortBy'],
        sortDirection: UserLayoutRequest['sortDirection'],
    ) => {
        setCriteria({sortBy, sortDirection});
    };

    return {criteria, setCriteria, setPage, setSort, reset, setPageSize};
}
